import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxCompanySelect', [
  'dataCache',
  function(dataCache) {
    return {
      restrict: 'E',
      template: `<a href="#"
                    editable-select="companyId"
                    onbeforesave="save({newValue:\$data})"
                    e-ng-options="company.id as company.name for company in companies "
                    e-placeholder="{{placeholder}}"
                    edit-disabled="disabled">
                  <span ng-show="companyId" ng-bind="company.name"></span>
                  <span ng-show="!companyId && showPlaceholderIfNull" ng-bind="placeholder"></span>
                  <i ng-show="!companyId && (!showPlaceholderIfNull || !placeholder)" class="glyphicon glyphicon-pencil" ></i>
                </a>`,
      scope: {
        companyId: '=data',
        save: '&',
        disabled: '=?',
        allowNull: '=?',
        placeholder: '@?',
        showPlaceholderIfNull: '=?',
      },
      controller: [
        '$scope',
        function($scope) {
          $scope.companies = dataCache.getCompanies().sort(dynamicSort('name'));

          $scope.$watch('companyId', function(newValue) {
            $scope.company = $scope.companies.find(x => x.id === newValue) || null;
          });
        },
      ],
    };
  },
]);
